import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import {
  editWebServiceProfitAdminService,
  getWebServiceProfitAdminService,
} from "../../../services/adminServices";

export const webServiceProfitAdminContext = createContext({
  webServiceProfit: {},
  setWebServiceProfit: () => {},
  handleGetWebServiceProfit: () => {},
  handleEditWebServiceProfit: () => {},
});

const WebServiceProfitAdminContext = ({ children }) => {
  const dispatch = useDispatch();

  const [webServiceProfit, setWebServiceProfit] = useState({});

  // Get Web Service Profit
  const handleGetWebServiceProfit = async (event) => {
    event?.preventDefault();

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getWebServiceProfitAdminService();
      if (status === 200) {
        setWebServiceProfit(data.result?.webServiceProfit);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Edit Web Service Profit
  const handleEditWebServiceProfit = async (userData) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await editWebServiceProfitAdminService(userData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetWebServiceProfit();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <>
      <webServiceProfitAdminContext.Provider
        value={{
          webServiceProfit,
          setWebServiceProfit,
          handleGetWebServiceProfit,
          handleEditWebServiceProfit,
        }}
      >
        {children}
      </webServiceProfitAdminContext.Provider>
    </>
  );
};

export default WebServiceProfitAdminContext;
